<template>
  <div>
    <van-nav-bar title="意见反馈" left-arrow @click-left="$router.back()" />
    <van-form class="form" @submit="onSubmit">
      <van-field v-model="form.content" class="content" type="textarea" rows="8" maxlength="500" show-word-limit label="内容" placeholder="请描述你的问题或建议" :rules="[{ required: true, message: '请填写反馈内容' }]" />
      <van-field v-model="form.contact" maxlength="50" label="联系方式" placeholder="可不填" />
      <div class="btn"><van-button round block type="info" native-type="submit">提交</van-button></div>
    </van-form>
  </div>
</template>

<script>
import { submitFeedback } from '../api'

export default {
  data() {
    return { form: { content: '', contact: '' } }
  },
  methods: {
    onSubmit() {
      submitFeedback(this.form).then(() => {
        this.$toast('已提交')
        this.form = { content: '', contact: '' }
      })
    }
  }
}
</script>

<style scoped>
.form { margin-top: 8px; }
.content ::v-deep .van-field__control { min-height: 180px; }
.btn { margin: 16px; }
</style>
